import Button from "../../../SharedComponents/Button";
import {BUTTON_VARIANT_TYPES, NO_ACCESS_TYPES, PERMISSIONS} from "../../../../utils/constants";
import {getOneTimeUrl} from "../../../../utils/api";
import {ExternalLinkIcon} from "@heroicons/react/solid";
import {useState} from "react";
import AccessControl from "../../../SharedComponents/AccessControl";

function App(props) {
    const {name, description, activated, colour, logoUrl, launchUrl, isStatic} = props;

    const [launching, setLaunching] = useState(false);

    const launchApp = async () => {
        setLaunching(true);
        try {
            if (isStatic) {
                window.open(launchUrl);
            } else {
                const oneTimeUrl = await getOneTimeUrl(name);
                window.open(oneTimeUrl);
            }
        } catch (err) {
            alert("The authentication failed, please try again or contact support.");
        }
        setLaunching(false);
    }

    return (
        <div className="bg-white shadow-sm w-full h-full rounded-lg grid grid-flow-row">
            <div className="p-4 grid grid-flow-row gap-5">
                <img className="h-6 col-span-3" src={logoUrl} alt="logo"/>
                <div className="font-medium text-indigo-900">
                    {name}
                </div>
            </div>
            <div className={"grid grid-flow-row gap-4 p-4 rounded-lg bg-gradient-to-r from-" + colour + "-50"}>
                <div className="text-sm text-indigo-900">
                    {description}
                </div>
                <div>
                    {activated ?
                        <AccessControl
                            requiredPermission={PERMISSIONS.LAUNCH_APPS}
                            noAccessType={NO_ACCESS_TYPES.BLANK}
                        >
                            <Button
                                onClick={launchApp}
                                colour={BUTTON_VARIANT_TYPES.UNCOLOURED}
                                text="Launch"
                                extraStyling={"w-full text-center justify-center bg-" + colour + "-600"}
                                icon={<ExternalLinkIcon className={"block h-4 w-4 ml-1"}/>}
                                loading={launching}
                            />
                        </AccessControl>
                        :
                        <Button colour={BUTTON_VARIANT_TYPES.GREEN} text={"Buy " + name}/>
                    }
                </div>
            </div>
        </div>
    );
}

export default App;